import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PinnaklSpinnerService } from '@pinnakl/shared/util-providers';
import { LocalSpinnerComponent } from '../local-spinner';

@Component({
  selector: 'pinnakl-spinner',
  templateUrl: 'global-spinner.component.html',
  imports: [LocalSpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['global-spinner.component.scss'],
})
export class PinnaklGlobalSpinnerComponent {
  private readonly spinning = toSignal(inject(PinnaklSpinnerService).isSpinning$, { initialValue: false });

  readonly branded = input(false);
  readonly forceVisible = input(false);
  protected readonly visible = computed(() => this.forceVisible() || this.spinning());
}
